package hk.com.vr360_demo2.webapp.component.verification


import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.useEffect

external interface VerificationProps : Props {
    var component: VerificationComponent
}
val VerificationScreen = FC<VerificationProps> { props ->
    div {
        +"關於我們"
        div {
            +"免責聲明"
        }
    }
    useEffect {
         props.component.navToEditor()
    }
}
